import { render, staticRenderFns } from "./PostRecord.vue?vue&type=template&id=fe270652&"
import script from "./PostRecord.vue?vue&type=script&lang=js&"
export * from "./PostRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports